import { render } from "./ArticleApplication.vue?vue&type=template&id=6c12863f"
import script from "./ArticleApplication.vue?vue&type=script&lang=js"
export * from "./ArticleApplication.vue?vue&type=script&lang=js"

import "./ArticleApplication.vue?vue&type=style&index=0&id=6c12863f&lang=scss"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__